import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/right-arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-31f8ef72"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = { class: "stage" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "discipline" }
const _hoisted_5 = ["title", "onClick"]

import useHomeStore from '@/store/modules/home'
import { storeToRefs } from 'pinia'
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue'
import { getSubjectOption } from '@/api/index'


export default {
  __name: 'subject-stage',
  setup(__props) {

const homeStore = useHomeStore()
const { allStage, academicStage, subject, subjectList, stageAndsubject, showSubjectSelect, current, homepageList, isLogin } = storeToRefs(homeStore)

//未登录显示 显示弹窗
watch(isLogin, () => {
  console.log('watch111')
  console.log('academicStage.value', academicStage.value)
  // !isLogin.value && 
  if (!academicStage.value.id) {
    console.log('watch1', academicStage.value.id, !academicStage.value.id)
    stageAndsubject.value = '全部学科'
    subjectList.value = [{
      dictName: '全部学科',
      id: null
    }]
    //显示学科学段让勾选
    showSubjectSelect.value = true
  }
})


//显示学科选段下拉框
const subjectClick = () => {
  showSubjectSelect.value = !showSubjectSelect.value
}

const subjectRef = ref()
const userClickOutside = (e) => {
  // console.log('e', e, !subjectRef.value.contains(e.target))
  // console.log('subjectRef.value', subjectRef.value)
  if (subjectRef.value && !subjectRef.value.contains(e.target)) {

    showSubjectSelect.value = false

    stageAndsubject.value = academicStage.value.dictName + (subject.value.dictName ? ' | ' + subject.value.dictName : '')
    if (academicStage.value.id === null || academicStage.value.id == undefined) {
      stageAndsubject.value = '全部学科'
    }
  }
}
onMounted(() => {
  document.addEventListener("click", userClickOutside);
})

onBeforeUnmount(() => {
  document.removeEventListener("click", userClickOutside);
})

//点击学段
const defaultStage = computed({
  get () {
    return academicStage.value.id
  },
  set (value) {
    academicStage.value.id = value
  }
})
const clickStage = (item, index) => {
  current.value = 1
  homepageList.value = []
  academicStage.value = { ...item }
  defaultStage.value = item.id


  defaultSubject.value = null
  subject.value = {}
  if (defaultStage.value === null) {
    subjectList.value = [{
      dictName: '全部学科',
      id: null
    }]
  }
  getSubjectOptionM(item.id)
  homeStore.getHomepageList()

}

//获取学科
const getSubjectOptionM = async (dictId) => {
  const res = await getSubjectOption({ dictId, dictLevel: 2 })
  if (res.code == 0) {
    subjectList.value = res.data
  }
}


//点击学科
const defaultSubject = computed({
  get () {
    return subject.value.id
  },
  set (value) {
    subject.value.id = value
  }
})
const clickSubject = (item, index) => {
  current.value = 1
  homepageList.value = []
  subject.value = item
  defaultSubject.value = item.id

  stageAndsubject.value = academicStage.value.dictName +' | ' + subject.value.dictName
  if (!academicStage.value.id) {
    stageAndsubject.value = '全部学科'
  }
  showSubjectSelect.value = false
  homeStore.getHomepageList()
}



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "subject curPointer",
    onClick: subjectClick,
    ref_key: "subjectRef",
    ref: subjectRef
  }, [
    _createElementVNode("span", null, _toDisplayString(_unref(stageAndsubject)), 1),
    _hoisted_1,
    _withDirectives(_createElementVNode("div", {
      class: "subjectSelect",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allStage), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["stage-item", defaultStage.value == item.id ? 'checked' :'']),
            onClick: $event => (clickStage(item,index)),
            key: index
          }, _toDisplayString(item.dictName), 11, _hoisted_3))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjectList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["discipline-item", defaultSubject.value == item.id ? 'checked' :'']),
            title: item.dictName,
            onClick: $event => (clickSubject(item,index)),
            key: index
          }, _toDisplayString(item.dictName), 11, _hoisted_5))
        }), 128))
      ])
    ], 512), [
      [_vShow, _unref(showSubjectSelect)]
    ])
  ], 512))
}
}

}